import styled from 'styled-components';
import { darken, lighten } from 'polished';

export const Container = styled.div`
  width: 100%;
  min-height: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  padding: 5px;
  border-radius: ${({ theme }) => theme.metrics.radius};
  background-color: ${({ theme }) => darken(0.1, theme.colors.background)};
`;

export const Dia = styled.button<{ selected?: boolean; cor: string }>`
  flex: 1;
  height: 100%;
  border-radius: ${({ theme }) => theme.metrics.innerRadius};
  background-color: ${({ theme, selected, cor }) =>
    selected ? cor : lighten(0.01, theme.colors.background)};
  color: ${({ theme, selected }) =>
    selected ? theme.colors.textPrimary : theme.colors.textBackground};
  transition: 0.2s;

  &:hover {
    background-color: ${({ theme, selected, cor }) =>
      darken(0.05, selected ? cor : theme.colors.background)};
  }
`;
